import { EuiButtonIcon, EuiText } from "@elastic/eui";
import { createUseStyles } from "react-jss";
import { COLORS } from "Consts";

interface StyleProps {
  disabled: boolean;
}

const useStyles = createUseStyles<string, StyleProps>({
  buttonContainer: {
    cursor: ({ disabled }) => (disabled ? "not-allowed" : "pointer"),
  },
  icon: {
    "&:hover": {
      color: ({ disabled }) => (disabled ? "inherit" : `var(--icon-button-hover) !important`),
      backgroundColor: ({ disabled }) => (disabled ? "transparent" : "var(--hover-background)"),
    },
  },
  iconSvg: {
    width: "40px",
    height: "40px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    paddingBottom: "1px",
    "&:hover": {
      color: ({ disabled }) => (disabled ? "inherit" : `var(--icon-button-hover) !important`),
      backgroundColor: ({ disabled }) => (disabled ? "transparent" : "var(--hover-background)"),
      borderRadius: "6px",
      paddingBottom: "3px",
    },
  },
  iconInvert: {
    color: ({ disabled }) => (disabled ? "inherit" : `${COLORS.$white} !important`),
    background: ({ disabled }) => (disabled ? "transparent" : COLORS.$lightBlue),
    "&:hover": {
      color: ({ disabled }) => (disabled ? "inherit" : `${COLORS.$buttonHover} !important`),
      backgroundColor: ({ disabled }) =>
        disabled ? "transparent" : "var(--hover-background) !important",
      background: "transparent",
    },
  },
});

export interface IconButtonProps {
  type?: string;
  disabled?: boolean;
  loading?: boolean;
  onClick: (e: any) => any;
  counter?: number | string | null;
  color?: string;
  icon?: any;
  style?: any;
  size?: any;
  iconSize?: "m" | "s" | "original" | "l" | "xl" | "xxl";
  text?: string | null | undefined;
  invert?: boolean;
}

const IconButton = ({
  type = "trash",
  icon = null,
  onClick,
  disabled = false,
  counter = null,
  color = COLORS.$blue,
  loading = false,
  size = "m",
  iconSize = "original",
  text = null,
  invert = false,
  style,
}: IconButtonProps) => {
  const classes = useStyles({ disabled });

  const handleClick = (e: any) => {
    if (!disabled && !loading) {
      onClick(e);
    }
  };

  return (
    <div className={classes.buttonContainer}>
      {icon ? (
        <div
          className={classes.iconSvg}
          style={{ display: text ? "inline-flex" : "flex", ...(style && style) }}
          onClick={(e) => {
            e.stopPropagation();
            handleClick(e);
          }}>
          {icon}
        </div>
      ) : (
        <EuiButtonIcon
          aria-label={type}
          size={size}
          iconType={type}
          iconSize={iconSize}
          className={!disabled && invert ? classes.iconInvert : classes.icon}
          style={{
            ...(style && style),
            color: disabled ? COLORS.$euiColorLightShade : color,
          }}
          onClick={(e) => {
            e.stopPropagation();
            handleClick(e);
          }}
          disabled={disabled}
          isLoading={loading}
        />
      )}
      {counter !== null && counter !== undefined && (
        <EuiText
          style={{
            display: "inline-block",
            fontSize: "var(--fs12)",
            paddingLeft: "4px",
            paddingRight: "10px",
            color: disabled ? COLORS.$euiColorLightShade : color,
          }}>
          {counter}
        </EuiText>
      )}

      {text !== null && text !== undefined && (
        <EuiText
          onClick={(e) => {
            e.stopPropagation();
            handleClick(e);
          }}
          style={{
            display: "inline-block",
            fontSize: "var(--fs14)",
            paddingLeft: "4px",
            paddingRight: "10px",
          }}
          color={color}>
          {text}
        </EuiText>
      )}
    </div>
  );
};

export default IconButton;
